import React, { useEffect, useState } from "react";
import { toKSTISOString } from "../common/commonMethod";

export const FxEnergyDetailPopup = (props) => {
  const { open, close } = props;
  const { energy, inloList, allValues } = props.data;

  const engNm = energy.engName;
  const values = allValues ? allValues[energy.engId] : undefined;

  const sourceItems = [];
  const targetItems = [];
  let srcTot = 0;
  let tgtTot = 0;
  //거래량이 없기에 임의로 만듬.
  const inloList1 = inloList.length % 2 == 0 ? inloList : inloList.splice(0, 1);

  inloList1.map(({ inloNo, inloName }, index) => {
    const a1 = values ? values[inloNo].now : undefined;
    const a2 = values ? values[inloNo].sum : undefined;
    const a3 = values ? String(a2).substring(0, 3) : undefined;

    if (index % 2 == 0) {
      sourceItems.push(
        <tr key={inloNo}>
          <td> {inloName} </td>
          <td className="textR">{a1}</td>
          <td className="textR">{a3}</td>
        </tr>
      );
      srcTot += Number(a3);
    } else {
      targetItems.push(
        <tr key={inloNo}>
          <td> {inloName} </td>
          <td className="textR">{a1}</td>
          <td className="textR">{a3}</td>
        </tr>
      );
      tgtTot += Number(a3);
    }
  });

  function time() {
    const TIME_ZONE = 3240 * 10000;
    const d = new Date();

    const date = toKSTISOString(new Date(+d + TIME_ZONE)).split("T")[0];
    const time = d.toTimeString().split(" ")[0];
    return date + " " + time + " ";
  }

  return (
    <>
      {open ? (
        <div className="popupBG" id="popupPage">
          <div className="popup">
            {/* <div className="closeBtn" onClick="javascript:popClose();"> */}
            <div className="closeBtn" onClick={close}>
              <img src="svgCloseBtn.svg" />
              <img src="svgCloseBtn_on.svg" />
            </div>
            <div className="popTitle titLine">
              <h1>{engNm}</h1>
              <p className="resultTit">
                {time()}
                기준
              </p>
            </div>
            <div className="resultChart chartLevel">
              <div>
                <div className="blueColor">Source</div>
                <div className="titleArea">
                  {srcTot}
                  <span> ton</span>{" "}
                </div>
                <div className="tableBox">
                  <table>
                    <thead>
                      <tr>
                        <th>공급업체명</th>
                        <th>전일평균</th>
                        <th>당일평균</th>
                      </tr>
                    </thead>
                    <tbody>{sourceItems}</tbody>
                  </table>
                </div>
              </div>
              <div className="arrowArea">
                <img src="popArrow.png" />
              </div>
              <div>
                <div className="blueColor">Sink</div>
                <div className="titleArea">
                  {tgtTot}
                  <span> ton</span>{" "}
                </div>
                <div className="tableBox">
                  <table>
                    <thead>
                      <tr>
                        <th>수요업체명</th>
                        <th>전일평균</th>
                        <th>당일평균</th>
                      </tr>
                    </thead>
                    <tbody>{targetItems}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
